import { Container } from '@cgs/wge';
import { CheatManager, CheatManagerToken } from '../cheat-manager';
import { ActiveCheat } from '../types';
import { CheatPopupElementToken } from './cheat-popup';
import { CheatUISection } from './cheat-ui-section';
import { getCheatUIStyles } from './styles';

export class CheatActiveUI extends CheatUISection {
  constructor(private container: Container) {
    super();

    this.container
      .resolve<CheatManager>(CheatManagerToken)
      .subscribe((activeCheat) => this.updateActiveCheat(activeCheat));

    this.initialize();
  }

  public initialize(): void {
    const consoleEl = this.container.resolve<HTMLDivElement>(CheatPopupElementToken);

    this.initializeBaseUI(consoleEl);
    this.setupActiveCheatUI();
    this.setupListeners();
  }

  private setupActiveCheatUI(): void {
    const styles = getCheatUIStyles();
    const activeCheatStyles = `
      color: #00ff95;
      padding: 8px;
      margin: 8px 0;
      font-size: 12px;
      min-height: 16px;
      background: rgba(0,255,149,0.1);
    `;

    const content = `
      <div style="${styles.sectionStyle}">
        <div style="margin-bottom: 8px;">
          <div>
            <p id="activeCheat" style="${activeCheatStyles}">No active cheat</p>
          </div>
          <button id="resetCheats" style="${styles.buttonStyle}">Reset</button>
        </div>
      </div>  
        `;

    this.contentEl.innerHTML = content;
  }

  private setupListeners(): void {
    const resetReelsBtn = this.getChildEl<HTMLButtonElement>('#resetCheats');
    const manager = this.container.resolve<CheatManager>(CheatManagerToken);
    if (resetReelsBtn) {
      resetReelsBtn.addEventListener('click', () => {
        manager.resetAllCheats();
      });
    }
  }

  private updateActiveCheat(activeCheat: ActiveCheat[] | null): void {
    const activeCheatEl = this.getChildEl<HTMLDivElement>('#activeCheat')!;

    if (!activeCheat || activeCheat.length === 0) {
      activeCheatEl.textContent = 'No active cheat';
      return;
    }

    activeCheatEl.innerHTML =
      `Active cheats: </br>` +
      (activeCheat || [])
        .map((cheat) => `${cheat.type}: ${JSON.stringify(cheat.value)}`)
        .join('</br>');
  }

  public destroy(): void {
    super.destroy();
  }
}
